'use client';

import type { EnterAuthConfig, EnterFingerprintConfig } from '@enter/auth';
import { getSwimLaneRequestHeaders } from '@enter/api';

function readEnvValue(value: string | undefined): string | undefined {
    return value && value.trim() ? value.trim() : undefined;
}

function readEndpointList(value: string | undefined): string[] | undefined {
    if (!value) {
        return undefined;
    }

    const endpoints = value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

    return endpoints.length > 0 ? endpoints : undefined;
}

export function getEnterFingerprintConfig(): EnterFingerprintConfig | null {
    const apiKey = readEnvValue(process.env.NEXT_PUBLIC_FINGERPRINTJS_PUBLIC_KEY);

    if (!apiKey) {
        return null;
    }

    const region = readEnvValue(process.env.NEXT_PUBLIC_FINGERPRINTJS_REGION);
    const endpoint = readEnvValue(process.env.NEXT_PUBLIC_FINGERPRINTJS_ENDPOINT);
    const endpoints = readEndpointList(readEnvValue(process.env.NEXT_PUBLIC_FINGERPRINTJS_ENDPOINTS));

    return {
        apiKey,
        ...(region ? { region: region as EnterFingerprintConfig['region'] } : {}),
        ...(endpoints ? { endpoints } : endpoint ? { endpoint } : {}),
    };
}

export function getEnterAuthConfig(getInviteCode?: EnterAuthConfig['getInviteCode']): EnterAuthConfig {
    return {
        apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
        fingerprint: getEnterFingerprintConfig(),
        getExtraHeaders: getSwimLaneRequestHeaders,
        getInviteCode,
        platform: 'web',
    };
}
